type AboutImageSet = {
  id: number
  images: string[]
}

export const aboutImages: AboutImageSet[] = [
  {
    id: 1,
    images: [
      'static/aboutus/carousel/sklad1.jpg',
      'static/aboutus/carousel/sklad3.jpg',
      'static/aboutus/carousel/sklad5.jpg',
      'static/aboutus/carousel/sklad6.jpg',
      'static/aboutus/carousel/sklad10.jpg',
      'static/aboutus/carousel/it1.jpg',
      'static/aboutus/carousel/it2.jpg',
      'static/aboutus/carousel/it7.jpg',
      'static/aboutus/carousel/content1.jpg',
      'static/aboutus/carousel/content3.jpg',
      'static/aboutus/carousel/support4.jpg',
      'static/aboutus/carousel/marketing4.jpg',
      'static/aboutus/carousel/marketing9.jpg'
    ]
  }
]
